import { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import UsersQuery from 'queries/space/users';
import UserAndUsersQuery from 'queries/space/user_and_users';
import OptionableAutocomplete from 'components/form/autocomplete/optionable';

const User = ({
  id,
  label,
  name,
  onChange,
  onBlur,
  value,
  error,
  helperText,
  placeId = null,
  showNotAssigned = false,
}) => {
  const intl = useIntl();
  const [searchValue, setSearchValue] = useState(null);
  const [defaultValue, setDefaultValue] = useState(null);
  const hydratedRef = useRef(false);

  const { data = { spaceUsers: { users: [], usersTotal: 0 }, spaceUser: null }, loading } =
    useQuery(value ? UserAndUsersQuery : UsersQuery, {
      variables: { page: 1, placeId: placeId, name: searchValue, userId: value },
    });

  useEffect(() => {
    if (!loading && !hydratedRef.current && data?.spaceUser) {
      hydratedRef.current = true;
      setDefaultValue({ label: data.spaceUser.email, value: data.spaceUser.id });
    }
  }, [data, loading]);

  const options = useMemo(() => {
    let inspectorOptions = data.spaceUsers.users.map((user) => ({
      label: user.email,
      value: user.id,
    }));
    if (showNotAssigned) {
      inspectorOptions.unshift({
        label: intl.formatMessage({ id: 'autocomplete.user.not_assigned' }),
        value: 0,
      });
    }
    return inspectorOptions;
  }, [data, intl, showNotAssigned]);

  const onChangeInternal = useCallback(
    (evt, value) => {
      setDefaultValue(value);
      onChange(evt, value);
    },
    [onChange]
  );
  return (
    <OptionableAutocomplete
      id={id}
      label={label}
      options={options}
      name={name}
      onChange={onChangeInternal}
      loadingText={intl.formatMessage({ id: 'autocomplete.user.loading' })}
      noOptionsText={<FormattedMessage id="autocomplete.user.no_options" />}
      value={defaultValue}
      onBlur={onBlur}
      loading={loading}
      error={error}
      helperText={helperText}
      onSearch={setSearchValue}
    />
  );
};

export default User;
